import { useEffect, useRef } from "react"
import { ImageCropEditData } from "./types"

export const useCleanupImageUrls = (editData: ImageCropEditData[]) => {
    const editDataRef = useRef(editData)

    useEffect(() => {
        editDataRef.current = editData
    }, [editData])

    useEffect(() => {
        return () => {
            editDataRef.current.forEach(img => {
                // Revoke all object URLs to avoid memory leaks
                URL.revokeObjectURL(img.url)
            })
        }
    }, [])
}
